import { createReducer } from 'redux-act';

import {
  WEB_TEMPLATE_FETCH,
  WEB_TEMPLATE_FETCH_DATA_SUCCESS,
  WEB_TEMPLATE_FETCH_DATA_FAIL,
  WEB_TEMPLATE_DELETE_INIT,
  WEB_TEMPLATE_DELETE_SUCCESS,
  WEB_TEMPLATE_DELETE_FAIL,
  WEB_TEMPLATE_CLEAR_DATA,
  WEB_TEMPLATE_CREATE_INIT,
  WEB_TEMPLATE_CREATE_SUCCESS,
  WEB_TEMPLATE_CREATE_FAIL,
  WEB_TEMPLATE_MODIFY_INIT,
  WEB_TEMPLATE_MODIFY_SUCCESS,
  WEB_TEMPLATE_MODIFY_FAIL,
  WEB_TEMPLATE_CLEAN_UP,
  WEB_TEMPLATE_CLEAR_DATA_LOGOUT,
} from 'state/actions/webTemplates';

const initialState = {
  list: [],
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const webTemplateReducer = createReducer(
  {
    [WEB_TEMPLATE_FETCH]: () => ({
      ...initialState,
      loading: true,
    }),
    [WEB_TEMPLATE_FETCH_DATA_SUCCESS]: (state, payload) => {
      console.log('payload web template', payload);
      return {
        ...state,
        list: payload.WEB_TEMPLATE.data || [],
        loading: false,
        error: null,
      };
    },
    [WEB_TEMPLATE_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_TEMPLATE_DELETE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_TEMPLATE_DELETE_SUCCESS]: (state, payload) => {
      return {
        ...state,
        list: state.list.filter((elem) => elem._id !== payload.id),
        loading: false,
        error: null,
        deleted: true,
      };
    },
    [WEB_TEMPLATE_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_TEMPLATE_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [WEB_TEMPLATE_CREATE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_TEMPLATE_CREATE_SUCCESS]: (state, payload) => {
      return {
        ...state,
        list: [...state.list, ...payload.template],
        loading: false,
        error: null,
        success: true,
        updated: true,
      };
    },
    [WEB_TEMPLATE_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_TEMPLATE_MODIFY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_TEMPLATE_MODIFY_SUCCESS]: (state, payload) => {
      console.log(state.list, payload);
      return {
        ...state,
        list: !state.list
          ? []
          : state.list.map((elem) => {
              if (elem._id === payload.id) {
                return (elem = payload.template);
              }
              return elem;
            }),
        loading: false,
        error: null,
        success: true,
        updated: true,
      };
    },
    [WEB_TEMPLATE_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_TEMPLATE_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
      updated: false,
    }),
    [WEB_TEMPLATE_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
  },
  initialState
);
